import React from 'react'
import System from 'src/helper/system';
import noImage from "src/assets/images/noimage.png";
import ProductLegends from '../ProductListing/ProductLegends';
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/helper/Helper';

const QuoteCheckoutCartList = () => {
    const [quoteList] = useReduxState({}, 'QuoteCartList')

    return (
        <div className="accordion accordion-with-arrow mycart-accordion mb-3 mt-3" id="mycart-accordion">
            <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne2">
                    <button id="collapseTwo" className="accordion-button font-16 collapsed" type="button" data-toggle="collapse" data-target="#collapseCart" aria-expanded="false" aria-controls="collapseCart">
                        My Cart
                    </button>
                </h2>
                <div id="collapseCart" className={'accordion-collapse collapse'} aria-labelledby="headingOne2" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                        <div className="cart-list-table table-responsive quote-cart-table">
                            <table className="table">
                                <tbody>
                                    {
                                        quoteList?.length > 0 &&
                                        quoteList?.map((v, i) => (
                                            <>
                                                <tr key={i}>
                                                    <td className="acc-product-img">
                                                        <div className="product-info nopadding">
                                                            <span className=''>Item: {i + 1}</span>
                                                            <div className="product-img sect-1 text-center">
                                                                <img src={(Helper.valueIsNotNull(v.assetURL))
                                                                    ? v.assetURL
                                                                    : noImage} alt='Product' />
                                                            </div>
                                                        </div>
                                                        <div className="prod-option-icon sect-2">
                                                            <div className="d-flex justify-content-start">
                                                                <ProductLegends
                                                                    single_product={v}
                                                                    onlyIcon={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="acc-product-name">
                                                        <>
                                                            <strong>{v?.erpMfrPartNumber}</strong> <br />
                                                            <div className="text-black-stone cursor-default">
                                                                {v.manufacturerName !== undefined &&
                                                                    <div>
                                                                        <span className='text-black'> by </span>
                                                                        {v.manufacturerName ? v.manufacturerName : ''}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </>
                                                    </td>
                                                    <td className="acc-product-info">
                                                        {v?.isProductAvailableFromMainAPI !== false &&
                                                            <div className="price-table-list ms-auto">
                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>Quantity:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: Number(v.quantity) })}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>Quantity Unit Price:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: Number(v.unitPrice) })}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>*Additional Charges1:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: Number(v.additionalCharge1) }) || "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>*Additional Charges2:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: Number(v.additionalCharge2) }) || "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>


                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>Subtotal:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: v.subtotal })}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default QuoteCheckoutCartList